import React, { useState } from "react";
import { darkModeBackgroud } from "../../../utils/constants";
import { NewAddComponentType } from "../../CustomDataGridStyle";
import { useDarkModeStore } from "../../../store/useDarkModeStore";
import { useLanguageStore } from "../../../store/useLanguageStore";
import List from "@mui/material/List";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import ToastMessage from "../../ToastMessage";
import ListItem from "@mui/material/ListItem";
import PRService from "../../../services/procurementService/PRService";
import RFQService from "../../../services/procurementService/RFQService";
import RFPService from "../../../services/procurementService/RFPService";
import documentTemplateService from "../../../services/general/documentTemplateService";
import useAddDocGenPR from "../../../store/ReactQueries/procurements/purchaseRequests/useAddDocGenPR";
import useAddDocGenRFP from "../../../store/ReactQueries/procurements/requestForProposal/useAddDocGenRFP";
import useAddDocGenRFQ from "../../../store/ReactQueries/procurements/requestForQuotation.ts/useAddDocGenRFQ";
import digitalSignatureService from "../../../services/procurementService/digitalSignatureService";
import purchaseOrderService from "../../../services/procurementService/purchaseOrderService";

interface ActionProcurementProp {
    page: number;
    pageSize: number;
    color?: string;
    styleClass?: string;
    id: string | undefined;
    newAddComponent: NewAddComponentType | undefined;
    handleDelete: ((id: string, confirmation?: boolean) => void) | undefined;
}

const ActionProcurementBtn = ({ id, styleClass, page, pageSize, color, newAddComponent, handleDelete }: ActionProcurementProp) => {
    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();

    const addDocTypeRFQ = useAddDocGenRFQ(page, pageSize);
    const addDocTypeRFP = useAddDocGenRFP(page, pageSize);
    const addDocTypePR = useAddDocGenPR(page, pageSize);

    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCreateClick = async (
        e: React.MouseEvent<HTMLLIElement, MouseEvent>
    ) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            let result;

            switch (newAddComponent) {
                case 'RequestForQuotations':
                    result = await RFQService.AddPurchaseOrder(id ?? '');
                    break;
                case 'RequestForProposals':
                    result = await RFPService.AddPurchaseOrder(id ?? '');
                    break;
                case 'PurchaseRequests':
                    result = await PRService.AddPurchaseOrder(id ?? '');
                    break;
                default:
                    console.warn(`Unknown component type: ${newAddComponent}`);
                    return;
            }

            if (result) {
                handleDelete && handleDelete(id ?? '', false);
            } else {
                console.error("Create operation failed:", result);
                ToastMessage.Failed();
            }
        } catch (error) {
            console.error("Failed to create:", error);
            ToastMessage.Failed();
        }
        setAnchorEl(null);
    };

    const handleGenDocument = async (
        e: React.MouseEvent<HTMLLIElement, MouseEvent>
    ) => {
        e.preventDefault();
        e.stopPropagation();
        setAnchorEl(null);
        try {
            const list = newAddComponent === 'RequestForQuotations'
                ? 'RequestForQuotationModule'
                : newAddComponent === 'RequestForProposals'
                    ? 'RequestForProposalModule'
                    : 'PurchaseRequestModule';

            let result = await documentTemplateService.GenerateDocument(list, id ?? '');

            if (result && id) {
                const form = { id, documentUrl: result.documentUrl };
                if (newAddComponent === 'RequestForQuotations') {
                    addDocTypeRFQ.mutate(form);
                } else if (newAddComponent === 'RequestForProposals') {
                    addDocTypeRFP.mutate(form);
                } else if (newAddComponent === 'PendingRequests') {
                    addDocTypePR.mutate(form);
                }
            }
            ToastMessage.Success();

        } catch (error) {
            const err = error as unknown as any;
            const message = err?.response?.data?.Message;
            ToastMessage.Failed(message ?? undefined);
        }
        setAnchorEl(null);
    };

    const handleSignDocument = async (
        e: React.MouseEvent<HTMLLIElement, MouseEvent>
    ) => {
        e.preventDefault();
        e.stopPropagation();
        setAnchorEl(null);
        try {
            let item;

            switch (newAddComponent) {
                case 'RequestForQuotations':
                    item = await RFQService.GetById(id ?? '');
                    break;
                case 'RequestForProposals':
                    item = await RFPService.GetById(id ?? '');
                    break;
                case 'PurchaseRequests':
                    item = await PRService.GetById(id ?? '');
                    break;
                case 'PurchaseOrders':
                    item = await purchaseOrderService.GetById(id ?? '');
                    break;
                default:
                    console.warn(`Unknown component type: ${newAddComponent}`);
                    return;
            }
            if (item && item.documentUrl) {
                const start = item.documentUrl.indexOf("/Uploads");
                let url = start !== -1 ? item.documentUrl.slice(start) : item.documentUrl;

                url = url.split(".pdf")[0] + ".pdf";

                await digitalSignatureService.SignDocument(url);
                ToastMessage.Success();
            } else {
                ToastMessage.Failed('Please generate the document first!');
            }

        } catch (error) {
            const err = error as unknown as any;
            const message = err?.response?.data?.Message;
            ToastMessage.Failed(message ?? undefined);
        }
        setAnchorEl(null);
    };

    return (
        <>
            <Button
                aria-describedby={Boolean(anchorEl) ? "simple-popover" : undefined}
                className="ms-auto "
                variant="text"
                title="Actions"
                onClick={handleClick}
            >
                <div
                    style={{
                        width: 100,
                        color: color ? color : darkMode ? "white" : "var(--color-pink)",
                    }}>
                    Action
                </div>
            </Button>
            <Popover
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                id={Boolean(anchorEl) ? "simple-popover" : undefined}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                sx={{
                    "& .MuiPopover-paper": {
                        marginLeft: "20px",
                    },
                }}
            >
                <List style={{ background: darkMode ? darkModeBackgroud : "white" }}>
                    <ListItem
                        role="button"
                        onClick={handleCreateClick}
                        className="text-center"
                        sx={{
                            paddingLeft: 3,
                            color: "#696CFF",
                            '&:hover': {
                                backgroundColor: "rgba(105, 108, 255, 0.08)",
                            },
                        }}
                    >
                        Create
                    </ListItem>
                    {
                        handleDelete
                        && <ListItem
                            role="button"
                            onClick={() => handleDelete(id ?? '')}
                            className="text-center"
                            sx={{
                                paddingLeft: 3,
                                color: "#696CFF",
                                '&:hover': {
                                    backgroundColor: "rgba(105, 108, 255, 0.08)",
                                },
                            }}
                        >
                            Delete
                        </ListItem>
                    }
                    <ListItem
                        role="button"
                        onClick={handleGenDocument}
                        className="text-center"
                        sx={{
                            paddingLeft: 3,
                            color: "#696CFF",
                            '&:hover': {
                                backgroundColor: "rgba(105, 108, 255, 0.08)",
                            },
                        }}
                    >
                        {language['GenerateDocument']}
                    </ListItem>
                    <ListItem
                        role="button"
                        onClick={handleSignDocument}
                        className="text-center"
                        sx={{
                            paddingLeft: 3,
                            color: "#696CFF",
                            '&:hover': {
                                backgroundColor: "rgba(105, 108, 255, 0.08)",
                            },
                        }}
                    >
                        {language['SignDocument']}
                    </ListItem>

                </List>
            </Popover>
        </>
    );
};

export default ActionProcurementBtn;
